// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui.top.attached.label:first-child+:not(.attached).content-padded-from-top {\n    margin-top: 50px!important;\n}\n", ""]);
// Exports
module.exports = exports;
